import React from 'react';
import { Box } from '@chakra-ui/react';
import TerminationForm from '../components/TerminationForm';

const Home = () => {

  return (
    <Box py={10}>
      <TerminationForm />
    </Box>
  );
};

export default Home;